<template>
  <div
    :class="{
      'top-menu fixed top-0 z-40 h-35px w-full bg-www-color-neutral-medium-dark': true,
      'items-center justify-end': true,
      'md:flex': user,
      hidden: true,
    }"
    data-testid="UtilityNavbar"
  >
    <LanguageSelector />
    <div
      :class="{
        'welcome-auth-desktop text-10px font-bold text-www-color-white': true,
      }"
    >
      Welcome, {{ user?.firstName }}!
    </div>
    <LinkWithIcon
      _type="generalLink"
      :text="customerHome.text"
      :link="customerHome.link"
      icon-name="ptc-portal"
    />
    <LinkWithIcon
      _type="generalLink"
      :text="openOnshape.text"
      :link="openOnshape.link"
      icon-name="ptc-sign-in-arrow"
      :class="{
        'h-full bg-www-color-neutral-medium': true,
      }"
    />
  </div>
  <div
    :class="{
      'top-menu fixed top-0 z-40 h-35px w-full bg-www-color-neutral-medium-dark': true,
      'items-center justify-end': true,
      'md:flex': !user,
      hidden: true,
    }"
  >
    <LanguageSelector />
    <LinkWithIcon
      _type="generalLink"
      :text="createStudentAccountButton.text"
      :link="createStudentAccountButton.link"
      icon-name="ptc-education"
      :class="{
        'h-full bg-[#617480]': true,
      }"
    />
    <LinkWithIcon
      _type="generalLink"
      :text="signinButton.text"
      :link="signinButton.link"
      icon-name="ptc-sign-in-arrow"
      :class="{
        'uppercase last-of-type:w-auto': true,
      }"
    />
  </div>
</template>

<script setup lang="ts">
import type { GeneralLink } from '~/sanity/types';

const { user, setParamsForFetch } = useCrossSession();
setParamsForFetch({ params: ['currentUserData'] });

defineProps<{
  createStudentAccountButton: GeneralLink;
  signinButton: GeneralLink;
  signupButton: GeneralLink;
  customerHome: GeneralLink;
  openOnshape: GeneralLink;
}>();
</script>
<style>
.top-menu .cta-button a span {
  display: flex;
  gap: 5px;
  align-items: center;
}

.lang_switcher_class .hover li a::after {
  border-bottom: 2px solid #40aa1d;
  content: '';
  display: block;
  left: 20%;
  position: absolute;
  top: 38px;
  width: 60%;
  z-index: 11;
}
</style>
